import { Mote } from './mote';
import { Language } from './language';
import { DatabaseModel, ModelJson } from './database-model';

export type MoteTranslation = { moteKey: string, language: Language };
export type SimpleTranslationMap = { [originKey: string]: MoteTranslation[] };
export type MoteLanguageMap = { [lang in Language]: Mote };
export type TranslationMap = { [originKey: string]: Mote[] };

export class TranslationModel extends DatabaseModel {

    public translationMap: SimpleTranslationMap = {};
    public key: string = "";

    constructor(key: string = '', json: ModelJson = null) {
        super();
        if(json) this.fromJson(json);
        if(key) this.key = key;
    }

    /**
     * Convert database json to TranslationModel instance (deserialize)
     */
    public fromJson(json: ModelJson): TranslationModel {
        Object.assign(this, json);
        return this;
    }

    /**
     * Convert TranslationModel instance to json (serialize)
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}
